import React, { useEffect } from 'react';
import { Page, Tooltip, Typography } from 'seagull';
import { useOverlayContext, useStore } from "../../contexts";
import InvoicesTable from "../../components/InvoicesTable/InvoicesTable";
import { selectors } from "../../store/state-selectors";
import { ErrorPage, NoInvoices } from "../../components/InvoicesEmptyStates/InvoicesEmptyStates";
import { ImportingInvoicesToQBOModal } from "./ImportingInvoicesToQBOModal";
import { QBOButton } from "./QBOButton";
import styles from "./InvoicesDashboard.module.scss";
import PageLoadingState from "../../components/PageLoadingState";
const pageTitle = 'Invoices';
export default function InvoicesDashboard() {
  const isVendor = useStore(selectors.user.isVendor);
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const {
    showModal
  } = useOverlayContext();
  useEffect(() => {
    document.title = pageTitle;
  }, []);
  return /*#__PURE__*/React.createElement(InvoicesTable, {
    filtersClassname: styles.filters,
    renderLoader: () => /*#__PURE__*/React.createElement(PageLoadingState, {
      header: pageTitle,
      loading: true,
      "data-testid": "invoices-dashboard-loading"
    }),
    renderError: _ref => {
      let {
        refresh
      } = _ref;
      return /*#__PURE__*/React.createElement(ErrorPage, {
        title: pageTitle,
        retry: () => refresh()
      });
    },
    renderNoInvoices: () => /*#__PURE__*/React.createElement(NoInvoices, {
      title: pageTitle,
      isVendor: isVendor
    }),
    renderChild: _ref2 => {
      let {
        tableContent,
        exportingCsv,
        exportCsv
      } = _ref2;
      return /*#__PURE__*/React.createElement(Page, {
        "data-testid": "invoices-dashboard",
        header: pageTitle,
        subheader: /*#__PURE__*/React.createElement(Typography, null, "Manage and review your invoices"),
        actions: isVendor && /*#__PURE__*/React.createElement(Tooltip, {
          title: showQboIntegration ? '' : 'Export the invoices displayed on this page to a CSV file in the format required for QuickBooks',
          placement: "bottom-end"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QBOButton, {
          "data-testid": "download-invoices-csv",
          hideIcon: showQboIntegration,
          loading: exportingCsv,
          onClick: async () => {
            exportCsv();
            if (!showQboIntegration) {
              await showModal({
                content: _ref3 => {
                  let {
                    dismissModal
                  } = _ref3;
                  return /*#__PURE__*/React.createElement(ImportingInvoicesToQBOModal, {
                    "data-testid": "importing-invoices-to-qbo-modal",
                    onClose: dismissModal,
                    downloadCsv: exportCsv
                  });
                }
              });
            }
          }
        }, "Export to CSV")))
      }, tableContent);
    }
  });
}